import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpleadosServicio } from '../../../services/empleado.service';
// import { ActivatedRoute, Params, Router  } from '@angular/router';

// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-editar-pass',
  templateUrl: './editar-pass.component.html',
  styleUrls: ['./editar-pass.component.css']
})
export class EditarPassComponent implements OnInit {
  form: FormGroup;
  @Input() id;

  modalMsg: any;
  mostrarError = false;
  loading = false;

  constructor(private empleadoService: EmpleadosServicio, public activeModal: NgbActiveModal) {
    this.initForm();
  }

  ngOnInit() {
    this.form.get('ID_EMPLEADO').setValue(this.id);
  }

  private initForm(): void {
    this.form = new FormGroup({
      'new_pass': new FormControl('', [Validators.required, Validators.minLength(6)]),
      're_pass': new FormControl('', [Validators.required, Validators.minLength(6)]),
      'ID_EMPLEADO': new FormControl('', Validators.required)
    });
  }

  editar() {
    this.mostrarError = false;

    if (this.form.get('new_pass').value !== this.form.get('re_pass').value) {
      this.modalMsg = { message: 'Las contraseñas no coinciden', error: true };
      this.mostrarError = true;
    } else {

      if (this.form.valid && !this.loading) {
        this.loading = true;
        this.empleadoService.editarPass(this.form.value).subscribe( res => {
          this.modalMsg = res;
          this.mostrarError = true;
          setTimeout(() => {
            this.mostrarError = false;
            if (!this.modalMsg.error) {
              this.activeModal.dismiss(); // Cierra la modal
            }
          }, 2300);
          this.loading = false;
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/editar-pass/editar-pass.component.ts